import React from 'react'
import {TwIcon} from '../containers'
import {TwLink, TwText} from './containers'
import {LinkProps} from './types'

export const Link = ({
  icon,
  iconAfter,
  title,
  onClick,
  onMouseDown,
  color = 'primary',
  size = 'md',
  disabled,
  forcedState,
  className,
  children,
  target = '_blank',
  href,
  style
}: LinkProps) => (
  <TwLink
    role="button"
    $color={color}
    $size={size}
    $disabled={disabled}
    $forcedState={forcedState}
    onClick={!disabled ? onClick : undefined}
    onMouseDown={!disabled ? onMouseDown : undefined}
    className={className}
    style={style}
    target={target}
    href={href}
  >
    {icon && <TwIcon icon={icon} viewBox="0 0 24 24" />}
    {children ?? (title && <TwText>{title}</TwText>)}
    {iconAfter && <TwIcon icon={iconAfter} viewBox="0 0 24 24" />}
  </TwLink>
)
